<nav class="hx-tree-host" [ngClass]="cssClass()">
  @if (shouldShowRouteAlert()) {
    <hx-alert
      appearance="outlined"
      title="Route-based navigation requires routes"
      variant="warning"
      [description]="'Missing route for: ' + missingRouteLabels()" />
  }
  @if (shouldShowSectionAlert()) {
    <hx-alert
      appearance="outlined"
      title="Section-based navigation requires ids"
      variant="warning"
      [description]="'Missing id for: ' + missingSectionLabels()" />
  }
  <ul class="hx-tree-root" role="tree" (keydown)="handleKeyDown($event)">
    @for (node of nodes(); track node.id; let last = $last) {
      <hx-tree-node
        [activeNodeId]="activeNodeId()"
        [collapsed]="collapsed()"
        [config]="config()"
        [expandedIds]="expandedNodeIds()"
        [focusedNodeId]="focusedNodeId()"
        [isLast]="last"
        [level]="0"
        [node]="node"
        [nodeTemplate]="nodeTemplate()"
        [readonly]="readonly()"
        [showChildIcons]="showChildIcons()"
        [showConnectorLines]="showConnectorLines()"
        [showStatusIcons]="showStatusIcons()"
        (nodeSelect)="handleNodeSelect($event)"
        (toggleId)="handleToggleId($event)" />
    }
  </ul>
</nav>
